import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = window.location.hash;
    const sid = new URLSearchParams(hash.replace("#", "")).get("session_id");
    (async () => {
      if (!sid) {
        navigate("/login", { replace: true });
        return;
      }
      try {
        const { data } = await api.post("/auth/session", { session_id: sid });
        if (data.token) localStorage.setItem("pm_token", data.token);
        setUser(data.user);
        window.history.replaceState(null, "", "/market");
        navigate("/market", { replace: true });
      } catch {
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-[#095F2E] to-[#0B7A3B]">
      <img src="/logo.png" alt="Pepperonni Market" className="w-20 h-20 rounded-2xl animate-pulse" />
      <p className="text-white/80 mt-4 font-semibold">Signing you in…</p>
    </div>
  );
}
